<h1 mat-dialog-title class="text-lg md:text-xl lg:text-2xl">Welcome to Blueapp!</h1>

<mat-dialog-content class="mat-typography p-4 md:p-5 lg:p-6">

    <div *ngIf="isLoading" class="loading-overlay fixed inset-0 bg-blue-200 bg-opacity-75 flex justify-center items-center z-10">
        <div role="status">
            <!-- Loading SVG & Text -->
            <svg class="animate-spin h-8 w-8 mr-2" viewBox="0 0 24 24">
                <!-- SVG content -->
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
            <span class="title-font font-medium">Loading...</span>
        </div>
    </div>

    <div *ngIf="!isLoading" class="content bg-white justify-center items-center">

        <p>Thank you for registering. Please upload your LinkedIn resume to complete your profile.</p>
        <div>
          <img src="assets/LinkedinPage.png" alt="LinkedIn Page" class="image-responsive">
        </div>
        <div class="mt-2 mb-2">
          <p class="text-black">
            <strong>1. First Log in/Sign in your linkedin account :<br></strong>
          </p>
          <button class="btn btn-primary" (click)="LinkedinSignin()"><i class="fa-brands fa-linkedin"></i> Log-in</button><br>

          <p class="text-black"> <strong>2. Second Build your resume from your profile: <br></strong><span><a style="color:blue" href="https://www.linkedin.com/jobs/?showResumeBuilderModal=true"></a></span></p><br>
          <button class="btn btn-primary" (click)="LinkedinResume()"><i class="fa-brands fa-linkedin"></i> Create Resume</button><br>

          <p class="text-black"><strong>3. Third Build your resume from your profile and upload it bellow!</strong></p>
        </div>
        <div class="flex flex-col items-center justify-center w-full">
          <input id="dropzone-file" type="file" class="" *ngIf="!isLoading" type="file" #fileInput accept=".pdf, .doc, .docx" (change)="handleFileInput($event)" />
        </div>

        <div *ngIf="selectedFile" class="file-info mt-1 text-center">
            <span class="file-name text-blue-600">{{selectedFile?.name}}</span>
        </div>

    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="mt-2">
    <button class="btn btn-primary" (click)="uploadResume()">Upload</button>
</mat-dialog-actions>
